module.exports = __webpack_public_path__ + "img/16x9_collage.ae5dbcc6.jpg";